import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import Select from 'react-virtualized-select';
import { withRouter } from 'react-router';

@withRouter
export default class UserFilter extends Component {
    static propTypes = {
        userId: PropTypes.number.isRequired,
        namePath: PropTypes.string.isRequired,
        userList: PropTypes.array.isRequired,
        route: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        disabled: PropTypes.bool,
    };

    onUserChange = user => {
        if (user) {
            const { history, route } = this.props;

            history.replace(route.stringify({ id: user.id }));
        }
    };

    render() {
        const { userList, namePath, userId, disabled } = this.props;

        return (
            <div className="antd-select-container user-filter">
                <Select
                    placeholder={<Translate content='placeholders.chooseManager' />}
                    clearable={false}
                    options={userList}
                    maxHeight={210}
                    value={userId}
                    onChange={this.onUserChange}
                    valueKey='id'
                    labelKey={namePath}
                    disabled={disabled}
                />
            </div>
        );
    }
}
